












































































































































































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, ref, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import Fuse from 'fuse.js';
import moment from 'moment';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string,
};

type Props = {
  tpid: string;
};

export default defineComponent({
  name: "ConceptHistory",
  props: {
    tpid: {
      type: String,
      default: ''
    }
  },
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/style.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" }
    ]
  },
  filters: {
    moment: function (date: string) {
      moment.locale('ja')
      return moment(date).format('YYYY/MM/DD')
    },
    strip: function(html: string) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.innerText;
    }
  },

  setup(props: Props, context: SetupContext) {
    const state = reactive({
      allConcepts: [] as Concept[],
      selectedConcepts: [] as string[],
    });

    const filter = ref('');
    const fuseOptions = {
      keys: ['name', 'title', 'description']
    };
    const pageSize = 10;
    const currentPage = ref(1);
    const pages = computed(() => {
      const cps = ((cs: Concept[], fv: string) => {
        if (fv.trim() === '') {
          return cs;
        } else {
          const fuse = new Fuse(state.allConcepts, fuseOptions);
          return fuse.search(filter.value).map(r => { return r.item });
        }
      })(state.allConcepts, filter.value);

      return cps.reduce(
        (pgs, _, i) => (i % pageSize ? pgs : [...pgs, cps.slice(i, i + pageSize)]), 
        [] as Concept[][]
      );
    });
    const concepts = computed(() => {
      return pages.value[currentPage.value - 1];
    });
    const fromNum = computed(() => {
      if (state.allConcepts.length === 0) {
        return state.allConcepts.length;
      } else {
        return (currentPage.value - 1) * pageSize + 1;
      }
    });
    const toNum = computed(() => {
      const to = (currentPage.value - 1) * pageSize + pageSize
      if (to > state.allConcepts.length) {
        return state.allConcepts.length;
      } else {
        return to;
      }
    });
    const matchCount = computed(() => {
      return pages.value.reduce((count, pgs, i) => (count + pgs.length), 0);
    });

    async function load() {
      console.log(props)
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/concepts', options).then(response => {
        console.log(response);
        state.allConcepts = response.data;
        console.log(state);
      }).catch(err => {
        console.log(err);
      });
    }
    load();

    async function multiCopyConcepts() {
      console.log(props.tpid)
      console.log(state.selectedConcepts);
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {
          tpid: props.tpid,
        },
        body: { ids: state.selectedConcepts }
      }

      API.post('dev', '/concepts/multicopy', options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ProjectDetail', params: { id: props.tpid } });
      }).catch(err => {
        console.log(err);
      });
    }

    return {
      state,

      filter,
      pageSize,
      pages,
      currentPage,
      concepts,
      fromNum,
      toNum,
      matchCount,

      multiCopyConcepts,
    };
  }


});
